import {Modal} from "react-bootstrap";
import {SvgIcon} from "../../ui/SvgIcon";
import Close from "../../images/newDesign/close.nocolor.svg";
import Button from "../../common/Button";
import {UploadFailedModalStyled} from "./UploadFailedModal.styled";
import {useTranslation} from "react-i18next";

export function UploadFailedModal({ item, onClose = (result) => void null }) {
    const {t} = useTranslation();
    return (
        <UploadFailedModalStyled show={true} onHide={() => onClose('close')} centered>
            <Modal.Header>
                <button onClick={() => onClose('close')}>
                    <SvgIcon href={Close} size={16}/>
                </button>
            </Modal.Header>
            <Modal.Body>
                <h1 className="bllink-heading1">{t('archive.upload_failed')}</h1>
                <center>
                    <div>{t('archive.upload_failed_message', { fileName: (<strong>{item.name}</strong>) })}</div>
                    <div>{t('archive.upload_failed_message_retry')}</div>
                    <Button onClick={() => onClose('close')}>{t('common.buttons.confirm')}</Button>
                </center>
            </Modal.Body>
        </UploadFailedModalStyled>
    );
}
